import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import i18n from '@/plugins/vue-i18n'
import vuetify from '@/plugins/vuetify'
import '@/plugins/components'
import '@/plugins/errorHandler' // importante que esté despues de vuetify
import '@/plugins/styles' // importante que esté despues de vuetify
import '@/plugins/components'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
